import { ReactNode } from 'react'

import { Box, SxProps, Typography } from '@mui/material'
import { AutomationTagIds } from 'assets/test/test-automation-tag-id'

type Props = {
  title?: string
  description?: string
  size?: 'small' | 'large'
  children?: ReactNode
  sx?: SxProps
  descriptionSx?: SxProps
  descriptionBoxSx?: SxProps
}

function Container({ title, description, size = 'large', children, sx, descriptionSx, descriptionBoxSx }: Props) {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', ...sx }}>
      <Box
        sx={{ width: size === 'small' ? { xs: '100%', md: '640px' } : { xs: '100%', sm: '600px', md: '816px', lg: '1232px' } }}
      >
        {(title || description) && (
          <Box
            sx={{
              textAlign: 'center',
              margin: '40px 0px'
            }}
          >
            {title && (
              <Box>
                <Typography variant='h1' data-testid={AutomationTagIds['tab.heading'] + '-' + title}>
                  {title}
                </Typography>
              </Box>
            )}
            {description && (
              <Box sx={{ marginTop: { xs: '0px', md: '14px' }, height: { xs: '18px', md: '28px' }, ...descriptionBoxSx }}>
                <Typography
                  variant='subtitle3'
                  sx={{ ...descriptionSx }}
                  data-testid={AutomationTagIds['tab.subheading'] + '-' + title}
                >
                  {description}
                </Typography>
              </Box>
            )}
          </Box>
        )}
        {children}
      </Box>
    </Box>
  )
}

export default Container
